export default __webpack_public_path__ + "static/media/GoldFrame07.140993b5.png";